// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterPropertyAddressesWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsRenterPropertyAddressesWebApiHandler_autocomplete,
  CappsRenterPropertyAddressesWebApiHandler_autocomplete_Path,
} from '@zg-rentals/ts-capps-client';

import type { RenterAddressAutocompleteWebResponseDto } from '@zg-rentals/ts-capps-client';

interface AutocompleteParams {
  partialAddress: string;
}

export type CappsRenterPropertyAddressesWebApiHandler_autocomplete_Options = UseQueryOptions<
  RenterAddressAutocompleteWebResponseDto,
  unknown,
  RenterAddressAutocompleteWebResponseDto,
  readonly [string, AutocompleteParams]
>;

const CappsRenterPropertyAddressesWebApiHandler_autocomplete_GetKey = (getParams: AutocompleteParams) =>
  [CappsRenterPropertyAddressesWebApiHandler_autocomplete_Path, getParams] as const;

export const CappsRenterPropertyAddressesWebApiHandler_autocomplete_queryOptions = (
  getParams: AutocompleteParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsRenterPropertyAddressesWebApiHandler_autocomplete_GetKey(getParams),
    queryFn: () => CappsRenterPropertyAddressesWebApiHandler_autocomplete(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get autocomplete addresses for a partial address
 */
export const useCappsRenterPropertyAddressesWebApiHandler_autocomplete = (
  getParams: AutocompleteParams,
  {
    httpClient,
    ...options
  }: Omit<CappsRenterPropertyAddressesWebApiHandler_autocomplete_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...CappsRenterPropertyAddressesWebApiHandler_autocomplete_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCappsRenterPropertyAddressesWebApiHandler_autocomplete.getKey =
  CappsRenterPropertyAddressesWebApiHandler_autocomplete_GetKey;
